"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createWindowOpenObservable = createWindowOpenObservable;
var browser_core_1 = require("@datadog/browser-core");
function createWindowOpenObservable() {
    var observable = new browser_core_1.Observable();
    var stop = (0, browser_core_1.instrumentMethod)(window, 'open', function () { return observable.notify(); }).stop;
    return { observable: observable, stop: stop };
}
//# sourceMappingURL=windowOpenObservable.js.map